import classNames from "classnames";
import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { formatStatus, ProcessingRequestStatus, ProcessingRequestStatuses } from "../../http/processingRequest/types";
import styles from "./Status.module.css";

export const Status: FC<{ status: ProcessingRequestStatus }> = ({ status }) => {
  const i18n = useI18n();

  return (
    <div
      className={classNames(styles.state, {
        [styles.open]: status === ProcessingRequestStatuses.Open,
        [styles.accepted]: status === ProcessingRequestStatuses.Accepted,
        [styles.waitingConfirmation]: status?.toLowerCase() === ProcessingRequestStatuses.WaitingConfirmation,
        [styles.offerApproved]: status === ProcessingRequestStatuses.OfferApproved,
        [styles.inProgress]: status === ProcessingRequestStatuses.InProgress,
        [styles.closed]: status === ProcessingRequestStatuses.Closed,
        [styles.refused]: status === ProcessingRequestStatuses.Refused,
        [styles.discarded]: status === ProcessingRequestStatuses.Discarded,
      })}
    >
      {formatStatus(status, i18n)}
    </div>
  );
};
